// extracted by mini-css-extract-plugin
module.exports = {"cell":"Machines_cell__1GJpc","actions":"Machines_actions__2p-LZ"};